enum StatsDataName {
  ORDER = "o"
}

export default StatsDataName;